"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = void 0;

var cookie = _interopRequireWildcard(require("cookie"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Context {
  constructor() {
    _defineProperty(this, "page", void 0);

    _defineProperty(this, "library", void 0);

    _defineProperty(this, "commonFields", void 0);

    _defineProperty(this, "campaign", void 0);

    _defineProperty(this, "screen", void 0);

    _defineProperty(this, "touch", void 0);

    _defineProperty(this, "userAgent", void 0);

    _defineProperty(this, "app", void 0);

    _defineProperty(this, "ssr", void 0);

    _defineProperty(this, "locale", void 0);

    _defineProperty(this, "timezone", void 0);

    _defineProperty(this, "os", void 0);

    this.page = {
      path: window.location.pathname,
      referrer: document.referrer,
      search: window.location.search,
      title: document.title,
      url: window.location.href
    };
    this.library = {
      name: 'telemetry-js',
      version: undefined || ''
    };
    this.os = {
      name: 'web'
    };
    const cookies = cookie.parse(document.cookie);
    this.commonFields = {
      dd_login_id: cookies.dd_login_id || null,
      dd_district_id: cookies.dd_district_id || null,
      dd_zip_code: cookies.dd_zip_code || null,
      dd_device_id: cookies.dd_device_id || null,
      dd_session_id: cookies.dd_session_id || null,
      dd_submarket_id: cookies.dd_submarket_id || null,
      dd_guest_id: cookies.dd_guest_id || null,
      dd_locale: cookies.dd_locale || null
    };

    if ('URLSearchParams' in window) {
      const params = new URLSearchParams(window.location.search.substring(1));
      this.campaign = {
        name: params.get('utm_campaign'),
        source: params.get('utm_source'),
        medium: params.get('utm_medium'),
        term: params.get('utm_term'),
        content: params.get('utm_content')
      };
    } else {
      this.campaign = {
        name: null,
        source: null,
        medium: null,
        term: null,
        content: null
      };
    }

    this.screen = {
      density: window.devicePixelRatio,
      width: window.innerWidth,
      height: window.innerHeight
    }; // These values are set in some packages in the web monorepo, and seem to be the desired value here (not what the values would be for this package)
    // For example, see: https://github.com/doordash/web/blob/e09ee395af7f4916d58a4b526e44cf7e6521b434/packages/app-consumer/package.json#L276

    this.app = {
      name: process.env.APP_NAME || '',
      version: process.env.APP_VERSION || '',
      build: process.env.APP_WEB_SHA || '',
      namespace: process.env.APP_ENV || ''
    };
    this.touch = 'ontouchstart' in window;
    this.userAgent = navigator.userAgent;
    this.locale = navigator.language;
    this.timezone = 'Intl' in window ? Intl.DateTimeFormat().resolvedOptions().timeZone : null; // eslint-disable-next-line @typescript-eslint/no-explicit-any

    this.ssr = window.is_ssr || false;
  }

}

exports.Context = Context;